<template>
  <div> 
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Expenses</b-navbar-brand>
        </b-navbar>

        <banner-component :allModuleIdBanner="jobDetails.JobId ? jobDetails.JobId : ''"
          :jobSeriesBanner="jobDetails.JobNo ? jobDetails.JobNo : ''"
          :bannerClientName="jobDetails.ClientName || jobDetails.ExpClientName" iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <b-row class="ml-0 mr-0">
                <b-col md="6">
                  <h5>
                    <b-badge class="ml-2" variant="info">Assignment Details</b-badge>
                  </h5>
                  <b-table show-empty stacked="md" :items="assignmentData" :fields="assignmentFields" responsive
                    class="position-relative">
                   
                  </b-table>
                  
                </b-col>
                <b-col md="6">
                  <h5>
                    <b-badge variant="info">Expense Document Details</b-badge>
                  </h5>
                  <b-table show-empty stacked="md" :items="ExpenseData" :fields="ExpenseDocumentFields" responsive
                    class="position-relative">
                    <template slot="SN" slot-scope="row">
                      {{ row.index + 1 }}
                    </template>
                    <template slot="approvalStatus" slot-scope="row3">
                      <b-badge 
                        v-if="row3.item.approvalStatus && row3.item.approvalStatus !== '-'"
                        :variant="getApprovalStatusVariant(row3.item.approvalStatus)"
                        style="font-size: 0.75rem; padding: 4px 8px;"
                      >
                        {{ row3.item.approvalStatus }}
                      </b-badge>
                      <span v-else class="text-muted">-</span>
                    </template>
                    <template slot="documentLink" slot-scope="row2">
                      <div class="d-flex align-items-center flex-wrap">
                        <div v-if="row2.item.documentLink" class="d-flex align-items-center">
                          <a 
                            href="javascript:void(0)" @click="openSignedDocument(row2.item.documentLink)"
                            class="btn btn-sm btn-outline-primary mr-2"
                            title="View Document"
                          >
                            <i class="fa fa-eye mr-1" aria-hidden="true"></i>View
                          </a>
                          <a 
                            href="javascript:void(0)" @click="openSignedDocument(row2.item.documentLink)"
                            class="btn btn-sm btn-outline-success mr-2"
                            title="Download Document"
                          >
                            <i class="fa fa-download mr-1" aria-hidden="true"></i>Download
                          </a>
                        </div>
      <b-button
                          v-if="isAdmin && row2.item.ape_id"
        size="sm"
        variant="outline-danger"
        pill
                          @click="removeExpenseDocument(row2.item)"
                          title="Remove Document (Admin Only)"
                          class="ml-1"
      >
                          <i class="fa fa-trash mr-1" aria-hidden="true"></i>Remove
      </b-button>
                        <span v-if="!row2.item.documentLink && !(isAdmin && row2.item.ape_id)" class="text-muted">-</span>
                      </div>
    </template>
                  </b-table>
                  </b-col>
              </b-row>
              <b-row align-v="start" class="mt-3">
                <b-col md="6">
                  <multi-file-uploader class="uploader-box" :documentName="'Expense_Multiple_Doc-'"
                    :otherDocName="'Expense_Multiple_Doc-'" :folderName="'Expense'" :accept="'*'"
                    :assign_no="jobDetails.JobNo || $sessionsStorage.get('JOBSERIES')" :multiple="true" v-model="form.singleUpload"
                    :state="Boolean(form.singleUpload)"
                    :fileAllModuleId="jobDetails.JobId ? String(jobDetails.JobId) : ''"></multi-file-uploader>
                  <span class="error" v-if="form.files_err ? true : false">{{ form.files_err }}</span>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Nature Of Expense" label-for="natureSelect" :state="!form.nature_of_expense_err">
                    <model-list-select id="natureSelect" :list="natureOfExpenseList" @input="getNatureOfExpenseTitle()"
                      option-value="label" option-text="label" v-model="form.nature_of_expense"
                      placeholder="Select Nature Of Expense" />
                    <b-form-invalid-feedback v-if="form.nature_of_expense_err">
                      {{ form.nature_of_expense_err }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="6"></b-col>
                <b-col md="6">
                  <b-form-group label="Remark" label-for="remarkInput" :state="!form.docRemark_err">
                    <b-form-textarea id="remarkInput" v-model="form.docRemark" rows="5" :maxlength="800" />
                    <div class="text-muted small mt-1">{{ (form.docRemark || '').length }}/800</div>
                    <b-form-invalid-feedback v-if="form.docRemark_err">
                      {{ form.docRemark_err }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="12" class="text-right action-footer">
                  <b-button class="mt-3" variant="primary" @click="adddragfilesINVDetail"
                    :disabled="!canSubmit || jobDetails.JobNo !== $sessionsStorage.get('JOBSERIES') || isSubmitting">
                    {{ isSubmitting ? 'Submitting...' : 'Save & Submit' }}
                  </b-button>
                  <md-spinner v-if="isSubmitting" md-indeterminate></md-spinner>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>

        <!-- Old & New Expenses Section -->
        <OldExpenseAdditionalTask
          v-if="$sessionsStorage.get('allModuleIdMain')"
          :allModuleId="$sessionsStorage.get('allModuleIdMain')"
          type="expense"
        />

        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
        <md-dialog-confirm 
          :md-content-html="confirmDelete.content" 
          :md-ok-text="confirmDelete.ok" 
          :md-cancel-text="confirmDelete.cancel"
          @close="onCloseDeleteConfirm"
          ref="addPopDelete">
        </md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import OldExpenseAdditionalTask from "../allModuleForm/components/OldExpenseAdditionalTask.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { GlobalGetNatureOfExpense, GlobalGetPurchaseExpense, findNatureOfExpenseByLabel } from "../../helper/collection";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import PaymentRequestService from "../../services/PaymentRequestService.js";
import { PaymentTypes } from "../../helper/PaymentHelper";

export default {
  beforeMount() {
    this.getAllNatureOfExpense();
    if (
      this.$sessionsStorage.get("allModuleIdMain") != undefined &&
      this.$sessionsStorage.get("JOBSERIES") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/allModule/Expenses");
      if (this.$sessionsStorage.get("allModuleIdMain")) {
        this.getData();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},

  data() {
    return {
      assignmentData: [],
      ExpenseData: [],
      form: {
        singleUpload: [],
        docRemark: "",
        docRemark_err: "",
        nature_id: "",
        nature_of_expense: "",
        nature_of_expense_err: "",
        files: [],
        files_err: "",
      },
      natureOfExpenseList: [],
      assignmentFields: [
        {
          key: "Job_Series",
          label: "Job No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "JobDate",
          label: "Job Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      ExpenseDocumentFields: [
      {
          key: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "expenseDate",
          label: "Expense Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "nature_of_expense",
          label: "Nature Of Expense",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "approvalStatus",
          label: "Approval Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentLink",
          label: "Actions",
          sortable: false,
        },
        {
          key: "remarks",
          label: "Remarks",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      confirmDelete: {
        content: "Are you sure you want to remove this expense document? This action cannot be undone.",
        ok: "Yes, Remove",
        cancel: "Cancel",
      },
      itemToDelete: null,
      jobDetails: {},
      isSubmitting: false,
    };
  },
  created() {

    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.form.singleUpload = file;
    });
  },

  mounted() { },

  destroyed() { },
  components: {
    ModelListSelect,
    CustomLoader,
    BannerComponent,
    MultiFileUploader,
    OldExpenseAdditionalTask,
  },
  computed: {
    // Button enabled only when all required inputs are present
    canSubmit() {
      const su = this.form.singleUpload;
      const hasFiles = typeof su === 'string' ? su.length > 0 : Array.isArray(su) && su.length > 0;
      return !!this.form.nature_of_expense && !!this.form.docRemark && hasFiles;
    },
    // Check if current user is admin
    isAdmin() {
      return this.$sessionsStorage.get('designation') === 'Admin' && this.$sessionsStorage.get('nameUser') === 'Bhavneesh'
    },
  },
  methods: {
    getNatureOfExpenseTitle() {
      const item = findNatureOfExpenseByLabel(this.natureOfExpenseList, this.form.nature_of_expense);
      if (item) {
        this.form.nature_id = item.nature_id;
        this.form.nature_of_expense = item.label;
      }
    },
    getAllNatureOfExpense() {
      const payload = { isSelectedColumn: 1, isAll: 1 };
      this.isLoading = true;
      GlobalGetNatureOfExpense(payload, (err, list) => {
        if (!err && Array.isArray(list)) {
          this.natureOfExpenseList = list;
        }
        this.isLoading = false;
      });
    },
    // Validate form fields and set error messages
    validateForm() {
      let valid = true;
      // reset
      this.form.nature_of_expense_err = "";
      this.form.docRemark_err = "";
      this.form.files_err = "";

      if (!this.form.nature_of_expense) {
        this.form.nature_of_expense_err = "Nature of Expense is required";
        valid = false;
      }
      const remark = (this.form.docRemark || "").trim();
      if (!remark) {
        this.form.docRemark_err = "Remark is required";
        valid = false;
      } else if (remark.length < 3) {
        this.form.docRemark_err = "Remark must be at least 3 characters";
        valid = false;
      }
      const su = this.form.singleUpload;
      const hasFiles = typeof su === 'string' ? su.length > 0 : Array.isArray(su) && su.length > 0;
      if (!hasFiles) {
        this.form.files_err = "Files Field is Required";
        valid = false;
      }
      return valid;
    },
    // Triggered by Save & Submit button
    async adddragfilesINVDetail() {
      // Validate inputs
      const ok = this.validateForm();
      if (!ok) {
        this.alert.content = "Please correct the highlighted fields.";
        this.$refs["addPop"].open();
        return false;
      }

      let item_new = [];
      this.isSubmitting = true;
      const fileStr = this.form.singleUpload || '';
      const FileArr = typeof fileStr === 'string' ? fileStr.split(",").filter(Boolean) : (Array.isArray(fileStr) ? fileStr : []);
      FileArr.forEach((element) => {
        let obj = {
          ape_id: element.ape_id || undefined,
          documentName: "Other",
          otherDocName: element,
          inv_doc: element,
          sc_remark: this.form.docRemark,
          addedFromMain: "5",
          payment_type: 1,
          fk_nature_id: this.form.nature_id,
          nature_of_expense: this.form.nature_of_expense,
          fk_module_id: this.jobDetails.JobId,
          jobSeries: this.jobDetails.JobNo,
        };
        item_new.push(obj);
      });
      try {
        await this.submitDocment(item_new, fileStr);
      } finally {
        this.isSubmitting = false;
      }
    },
    async submitDocment(item_new, New_generated_file) {
      
      let submitPayload = {
        TaskDetails: item_new,
        generated_file: New_generated_file,
        nature_of_expense: this.form.nature_of_expense,
        nature_id: this.form.nature_id,
        docRemark: this.form.docRemark,
        fk_module_id: this.jobDetails.JobId,
        allModuleId: this.jobDetails.JobId,
        jobSeries: this.jobDetails.JobNo,
      };
      console.log("submitPayload", submitPayload);
      // return
      // Only Node API
      try {
        const result = await PaymentRequestService.addExpenseDocument(submitPayload);
        const { status, data } = result || {};
        if (status === 200 && data) {
          this.alert.content = (data && (data.message || data.msg)) ? (data.message || data.msg) : "Saved Successfully";
          this.$refs["addPop"].open();
          this.form.singleUpload = [];
          this.getData();
        }
      } catch (e) {
        // Optionally surface an error message
        console.warn("addExpenseDocument error", e);
      } finally {
        this.isSubmitting = false;
        this.getData();
        // submit state is handled by caller (adddragfilesINVDetail), keep this clean
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    removeExpenseDocument(item) {
      if (!item.ape_id) {
        this.alert.content = "Cannot remove: Document ID not found.";
        this.$refs["addPop"].open();
        return;
      }

      const ape_id = Number(item.ape_id);
      if (!ape_id || ape_id <= 0) {
        this.alert.content = "Invalid Expense ID. Please provide a valid ape_id.";
        this.$refs["addPop"].open();
        return;
      }

      // Store the item to delete and show confirmation dialog
      this.itemToDelete = item;
      this.$refs["addPopDelete"].open();
    },
    async onCloseDeleteConfirm(type) {
      if (type !== "cancel" && this.itemToDelete && this.itemToDelete.ape_id) {
        const ape_id = Number(this.itemToDelete.ape_id);
        if (!ape_id || ape_id <= 0) {
          this.alert.content = "Invalid Expense ID. Please provide a valid ape_id.";
          this.$refs["addPop"].open();
          this.itemToDelete = null;
          return;
        }

        this.isLoading = true;
        try {
          const payload = {
            ape_id: ape_id,
          };

          const result = await PaymentRequestService.deletePurchaseExpense(payload);
          const { status, data } = result || {};
          
          if (status === 200 && data) {
            this.alert.content = (data && (data.message || data.msg)) ? (data.message || data.msg) : "Document removed successfully";
            this.$refs["addPop"].open();
            this.getData(); // Refresh the list
          } else {
            this.alert.content = "Failed to remove document. Please try again.";
            this.$refs["addPop"].open();
          }
        } catch (e) {
          console.error("removeExpenseDocument error", e);
          this.alert.content = "An error occurred while removing the document.";
          this.$refs["addPop"].open();
        } finally {
          this.isLoading = false;
        }
      }
      this.itemToDelete = null;
    },
    getApprovalStatusVariant(status) {
      if (!status || status === '-') return 'secondary';
      const statusUpper = String(status).toUpperCase();
      if (statusUpper === 'APPROVED') return 'success';
      if (statusUpper === 'PENDING' || statusUpper === 'PENDING APPROVAL') return 'warning';
      if (statusUpper === 'REJECTED' || statusUpper === 'REJECT') return 'danger';
      return 'info';
    },
    getData() {
      this.isLoading = true;
      const payload = {
        fk_module_id: Number(this.$sessionsStorage.get("allModuleIdMain")),
        is_children: 1,
        payment_type: PaymentTypes.EXPENSE,
        isList:0,
      };
      GlobalGetPurchaseExpense(payload, (err, result) => {
        const raw = result && result.raw ? result.raw : {};
        const job = (result && result.jobDetails) || raw.jobDetails || raw.JobDetails || null;
        this.jobDetails = job;

        this.ExpenseData = result && raw.data ? raw.data.map((item,index) => {
          return {
            SN: index + 1,
            expenseDate: item.inv_date,
            documentLink: item.inv_doc ? `ASSIGNMENT_UPLOADS/${(job.JobNo || this.jobDetails.JobNo || '').replaceAll('/', '_')}/${item.inv_doc.replaceAll('/', '_')}` : null,
            remarks: item.sc_remark || '-',
            ape_id: item.ape_id || null,
            inv_doc: item.inv_doc || null,
          }
        }) : [];
        if (job) {
          this.assignmentData = [
            {
              Job_Series: job.JobNo || this.$sessionsStorage.get("JOBSERIES") || "-",
              JobDate: job.JobDate || this.$sessionsStorage.get("JOBDATE") || "-",
              clientName:
                job.clientName || job.ExpClientName || job.ImpClientName || this.$sessionsStorage.get("CLIENTNAME") || "-",
              POD: job.POD || this.$sessionsStorage.get("POD") || "-",
            },
          ];
        } else {
          // Safe fallback to avoid empty array access in template
          this.assignmentData = [
            {
              Job_Series: this.$sessionsStorage.get("JOBSERIES") || "-",
              JobDate: this.$sessionsStorage.get("JOBDATE") || "-",
              clientName: this.$sessionsStorage.get("CLIENTNAME") || "-",
              POD: this.$sessionsStorage.get("POD") || "-",
            },
          ];
        }
        this.isLoading = false;
      });
    },

  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}

/* Lite UI polish */
.uploader-box {
  min-height: 90px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  padding: 10px;
}

.action-footer {
  border-top: 1px solid #edf2f7;
  padding-top: 12px;
}
</style>



// WEBPACK FOOTER //
// ExpensesLite.vue?f64457fa